import React from 'react';
import { Smartphone } from 'lucide-react';
import EventForm from '../components/EventForm';
import ScreenHeader from '../components/ScreenHeader';
import SaveButton from '../components/SaveButton';
import PasteScreenshot from '../components/PasteScreenshot';

export default function AddScreen({
  addForm,
  selectedTags, toggleTag,
  cameFromNav, lastScreen,
  setCurrentScreen,
  setShowUploadModal,
  handleSaveNewEvent,
  screenshotImageUrl,
  onScreenshotParsed,
}) {
  // When a screenshot image URL is present, show the OCR/parse/review flow
  if (screenshotImageUrl) {
    return (
      <div className="h-full flex flex-col bg-white">
        <ScreenHeader
          title="Create from Screenshot"
          onBack={() => onScreenshotParsed({ confidence: 'cancelled' })}
          titleClassName="text-2xl font-bold text-gray-900"
        />
        <PasteScreenshot
          imageUrl={screenshotImageUrl}
          onComplete={onScreenshotParsed}
        />
      </div>
    );
  }

  // Normal manual entry form
  return (
    <div className="h-full flex flex-col bg-white">
      <ScreenHeader
        title="Add Event"
        onBack={!cameFromNav ? () => setCurrentScreen(lastScreen) : undefined}
        titleClassName="text-2xl font-bold text-gray-900"
        rightAction={
          <button
              onClick={() => setShowUploadModal(true)}
              className="p-2 bg-blue-600 hover:bg-blue-700 rounded-lg transition-colors"
              title="Paste Screenshot"
            >
              <Smartphone size={20} className="text-white" />
            </button>
        }
      />

      {/* Manual Entry Form */}
      <EventForm form={addForm} selectedTags={selectedTags} toggleTag={toggleTag} showNotifications />

      <SaveButton onSave={handleSaveNewEvent} isSaving={addForm.isSaving} />
    </div>
  );
}
